/* 提现记录 */
<template>
  <div class="reflect-record-box">
    <!-- 头部 -->
    <headerTop title="提现记录">
      <span slot="left">
        <div class="return">
          <span class="iconfont iconfanhui"></span>
        </div>
      </span>
    </headerTop>
    <!-- 内容 -->
    <div class="content">
      <van-list
        v-if="!(dataFinished && dataList.length == 0)"
        v-model="dataLoading"
        :finished="dataFinished"
        finished-text="没有更多了"
        @load="dataLoad"
      >
        <div class="content-item" v-for="item in dataList" :key="item.id">
          <div class="date-state">
            <span>提现—到{{ item.payee_bank_name }}({{item.payee_bank_card.substring(item.payee_bank_card.length - 4)}})</span>
            <span>{{ item.status_name }}</span>
          </div>
          <div class="user-information">
            <span>
              ￥{{ item.price }}
              <label>(手续费：{{ item.service_price }})</label>
            </span>
            <span>{{ item.create_time.substring(0, 16) }}</span>
          </div>
        </div>
      </van-list>
      <noDataNote v-else background="#ffffff" :type="0" note="暂无提现记录"></noDataNote>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/common/headerTop.vue";
import accountApi from "@/api/accountApi";
import noDataNote from "@/components/common/noDataNote.vue";

export default {
  data() {
    return {
      dataList: [],
      dataLoading: false,
      dataFinished: false,
      dataTotalPage: 1,
      dataPage: 1,
      dataPageSize: 10
    };
  },
  components: {
    headerTop,
    noDataNote
  },
  methods: {
    // 请求接口调用数据
    dataLoad() {
      let data = {
        page: this.dataPage,
        page_size: this.dataPageSize
      };
      accountApi.accountWithdraw(data).then(res => {
        // Java 契约：列表在 data（PHP 是 datas），总页数是 pageCount（PHP 是 last_page）
        const tempData = res.data || [];
        this.dataList = this.dataList.concat(tempData);
        this.dataTotalPage = res.pagination ? res.pagination.pageCount : 1;
        this.dataLoading = false;
        if (this.dataPage >= this.dataTotalPage) {
          this.dataFinished = true;
        }
        this.dataPage++;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.reflect-record-box {
  .content {
    padding: 0 15px;
    .content-item {
      height: 99px;
      width: 100%;
      border-bottom: 1px solid #e4e4e4;
      .date-state {
        display: flex;
        padding-top: 30px;
        span {
          flex: 1;
          white-space: nowrap;
        }
        & span:nth-child(1) {
          color: #333;
          font-size: 14px;
        }
        & span:nth-child(2) {
          text-align: right;
          font-size: 16px;
          color: #EA2C2C;
          font-weight: 700;
        }
      }
      .user-information {
        display: flex;
        padding-top: 9px;
        span {
          flex: 1;
          white-space: nowrap;
          label {
            font-size: 12px;
            color: #666666;
          }
        }
        & span:nth-child(1) {
          font-size: 16px;
          color: #333;
        }
        & span:nth-child(2) {
          text-align: right;
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
}
</style>
